var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import PropTypes from "prop-types";
export var Skeleton = function (_a) {
    var _b;
    var loading = _a.loading, children = _a.children, _c = _a.shape, shape = _c === void 0 ? "square" : _c, _d = _a.block, block = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? 100 : _e, _f = _a.height, height = _f === void 0 ? 16 : _f, multiply = _a.multiply, _g = _a.marginMultiply, marginMultiply = _g === void 0 ? 10 : _g, avatar = _a.avatar, otherProps = __rest(_a, ["loading", "children", "shape", "block", "width", "height", "multiply", "marginMultiply", "avatar"]);
    var skeletonWidth = block && shape !== "circle" ? "100%" : "".concat(width, "px");
    var skeletonHeight = shape === "circle" ? width : height;
    var classNames = classnames((_b = {
            "mex-skeleton": true
        },
        _b["mex-skeleton--".concat(shape)] = true,
        _b));
    if (!loading)
        return _jsx(_Fragment, { children: children });
    var avatarWidth = 100;
    var AvatarEl = null;
    if (avatar) {
        if (typeof avatar === "object" && avatar.width)
            avatarWidth = avatar.width;
        AvatarEl = _jsx("div", { className: "mex-skeleton__avatar", style: { width: avatarWidth, height: avatarWidth } });
        if (!multiply)
            return (_jsxs("div", __assign({ className: "mex-skeleton--with-avatar" }, { children: [AvatarEl, _jsx("div", __assign({ className: classNames, style: { width: skeletonWidth, height: skeletonHeight } }, otherProps))] })));
    }
    if (multiply) {
        var MultiplySkeleton = (_jsx("div", __assign({ className: "mex-skeleton--multiply" }, { children: Array.from(Array(multiply)).map(function (val, key) { return (_jsx("div", __assign({ className: classNames, style: { width: skeletonWidth, height: skeletonHeight, marginBottom: marginMultiply } }, otherProps), key)); }) })));
        return avatar ? (_jsxs("div", __assign({ className: "mex-skeleton--with-avatar" }, { children: [AvatarEl, MultiplySkeleton] }))) : (MultiplySkeleton);
    }
    return _jsx("div", __assign({ className: classNames, style: { width: skeletonWidth, height: skeletonHeight } }, otherProps));
};
Skeleton.propTypes = {
    shape: PropTypes.oneOf(["circle", "square", "round"]),
    block: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    style: PropTypes.object,
    multiply: PropTypes.number,
    marginMultiply: PropTypes.number,
};
Skeleton.defaultProps = {
    shape: "square",
    width: 100,
    height: 16,
    marginMultiply: 10,
};
export default Skeleton;
